import { UnifiedComponentsCollection } from '../../../../types/unifiedComponents';

export function serializePages(
  pages: UnifiedComponentsCollection['pages'],
): string {
  return Object.entries(pages)
    .map(([pageExtId, container]) => {
      const widgets = container.data.content?.widgets
        ?.map((w) => w.widgetGuid)
        .filter((id) => !!id)
        .join(',');
      return widgets ? `${pageExtId}:${widgets}` : pageExtId;
    })
    .join('|');
}

export function serializeRouters(
  routers: UnifiedComponentsCollection['routers'],
): string {
  return Object.entries(routers)
    .map(([routerId, { data }]) => {
      const prefix = data.preferredPrefix ?? '';
      const pages =
        data.pages
          ?.map((p) => p.pageExtentionId)
          .filter((id) => !!id)
          .join(',') ?? '';
      return `${routerId}:${prefix}:${pages}`;
    })
    .join('|');
}

export function serializeIds(record: Record<string, unknown>): string {
  return Object.keys(record).join(',');
}

export function serializeCodePackages(
  codePackages: UnifiedComponentsCollection['codePackages'],
): string {
  return codePackages
    .map((pkg) => pkg.importName)
    .filter((name) => !!name)
    .join(',');
}
